export enum FilterListFieldType {
  VEH_SIDE_NUMBER = 'VEH_SIDE_NUMBER',
  LINE = 'LINE',
  TEAM = 'TEAM',
  DIRECTION_NAME = 'DIRECTION_NAME',
  TYPEOFDAY = 'TYPEOFDAY',
  SP_CODE = 'SP_CODE',
  SP_NAME = 'SP_NAME',
  CARRIER = 'CARRIER',
  DEPOT = 'DEPOT',
  VEHICLE_GROUP = 'VEHICLE_GROUP',
  COURSE = 'COURSE',
  STOP_PILE_EVENT_TYPE_RAW = 'STOP_PILE_EVENT_TYPE_RAW',
  STOP_PILE_EVENT_TYPE_STAT = 'STOP_PILE_EVENT_TYPE_STAT'
}
